import React, {memo, useEffect, useState} from 'react';
import {View} from 'react-native';

import { StyleSheet } from 'react-native';
import {colorPalette, colors} from '../../../core/config/color.config';

import {RNEText} from '../../components';
import {ConsultationStatusEnum} from '../../server/types/consultation.types';
import {ProcedureStatusEnum} from '../../server/types/procedure.types';
import { width, height, totalSize } from 'react-native-dimension';
import { useRoute } from '@react-navigation/native';

interface ConsultationStatusProps {
  consultationStatus?: ConsultationStatusEnum;
  procedureStatus?: ProcedureStatusEnum;
  isActionByPatient?: boolean;
}

const ConsultationStatus = (props: ConsultationStatusProps) => {
    const route = useRoute();
    const currentScreen = route.name;

  
  const [statusData, setStatusData] = useState<{
    label: string;
    bgColor: string;
  }>();

  useEffect(() => {
    switch (props.consultationStatus) {
      case ConsultationStatusEnum.COMPLETED:
        setStatusData({
          label: 'Completed',
          bgColor: colorPalette.secondary,
        });
        break;

      case ConsultationStatusEnum.DECLINED:
        setStatusData({
          label: props.isActionByPatient ? 'Cancelled' : 'Declined',
          bgColor: colorPalette.pendingPayment,
        });
        break;

      case ConsultationStatusEnum.CANCELLED:
        setStatusData({
          label: props.isActionByPatient ? 'Cancelled' : 'Declined',
          bgColor: colorPalette.pendingPayment,
        });
        break;

      case ConsultationStatusEnum.PENDING:
        setStatusData({
          label: 'Pending Approval',
          bgColor: colorPalette.pendingPayment,
        });
        break;
      case ConsultationStatusEnum.ARCHIVED:
        setStatusData({
          label: 'Archived',
          bgColor: colors.red.regular,
        });
        break;

      default:
        break;
    }

    if (props.procedureStatus) {
      if (
        props.consultationStatus === ConsultationStatusEnum.PENDING &&
        props.procedureStatus === ProcedureStatusEnum.TO_PAY
      ) {
        setStatusData({
          label: 'Pending Payment',
          bgColor: colorPalette.pendingPayment,
        });
      }
    }
  }, [
    props.consultationStatus,
    props.procedureStatus,
    props.isActionByPatient,
  ]);

  return (
    <View
      style={[
        styles.status,
        currentScreen === 'history' && ({alignItems: 'flex-start'})
      ]}>
      <RNEText
        label={statusData?.label.toUpperCase() ?? ''}
        color="white"
        variant="button"
        // weight="600"
        style={{...fontStyle, color: statusData?.bgColor}}
      />
    </View>
  );
};

const fontStyle = {
  fontSize: totalSize(1.2),
  fontFamily: 'Quicksand-SemiBold'
  // textAlign: 'center'
};

const styles = StyleSheet.create({
  status: {
    // width: 90,
    width: width(30),
    // alignItems: 'center',
    // borderRadius: 100,
    // paddingHorizontal: 12,
    // paddingHorizontal: width(1),
    // paddingVertical: 6,
    backgroundColor: 'transparent',
    // height: 25,
    justifyContent: 'center',
    marginTop: height(0.2),
    marginRight: totalSize(2)
  },
});

export default memo(ConsultationStatus);
